module.exports = __webpack_public_path__ + "img/placeholder.335f2a4f.png";